<template>
  <v-footer color="blue-grey darken-2 text-white" dark dense>
      <v-container text-center>
        <v-icon class="mr-2">fas fa-copyright</v-icon>{{ year }}
        <span class="font-weight-light ml-2">{{ footer }}</span>
      </v-container>
    </v-footer>
</template>

<script>
import { getToday } from '@/utils/DateUtil';

export default {
  name: "Footer",
  props: {
    footer: {
      type: String,
      default: ""
    }
  },
  data(){
    return {
      year: getToday().toFormat('yyyy')
    }
  }
};
</script>